import { PageId } from 'constants/pages'

export const enum PageIdIntlD70 {
  OFFER = PageId.OFFER_INTL_D70,
  PAYMENT = PageId.PAYMENT_INTL_D70,
  CHECKOUT = PageId.CHECKOUT_INTL_D70,
  UPSELL = PageId.UPSELL_INTL_D70,
  REGISTRATION = PageId.REGISTRATION_INTL_D70,
  NAME_ENTRY = PageId.NAME_ENTRY_INTL_D70,
  CERTIFICATE = PageId.CERTIFICATE_INTL_D70,
  LEARNWORLDS_REDIRECT = PageId.LEARNWORLDS_REDIRECT_INTL_D70,
  REPORT = PageId.REPORT_INTL_D70,
}
